// Module
var code = "<span class=text-tooltip><button><i class=\"icon icon-information\" type=button data-toggle=popover title=\"\" data-content={{text}}></i></button></span>";
// Exports
module.exports = code;